import { JourneyRoute } from '@cash-web/shared-journey-util-main'

export const investingJourneyRoutes = [
  {
    id: 'round-ups-onboarding',
    trackingName: 'Round Ups Onboarding',
    path: 'investing/round_ups_onboarding',
    lazy: async () => ({
      Component: (await import('../components/JourneyRoundUpsOnboarding')).JourneyRoundUpsOnboarding,
      props: { isEditing: false },
    }),
  },
] as const satisfies JourneyRoute[]
